import { DefaultWorklistASAMs } from "enums/Methods";
import { SeedingStrategy } from "features/WorklistTools/shared/interfaces";
import {
  calculateSpinParamGForce,
  getValueInDetailsString,
} from "features/WorklistTools/shared/WorklistHelpers";
import { Maybe } from "graphql-tools";
import { WorklistToolTemplateContent } from "graphql/generated/schema-types";
import { IExternalThawMethodSettings } from "../../state/initial-state";

export const parseTemplateWellMappings = (
  worklistValues: Maybe<Maybe<WorklistToolTemplateContent>[]> | undefined,
) => {
  const parsedWorklistValues = worklistValues?.map((row) => ({
    sourcePlateIndex: row!.sourcePlatePosition,
    sourceWellId: row!.sourceWellId,
    destPlateIndex: row!.destinationPlatePosition,
    destWellId: row!.destinationWellId,
    transferVol: row!.transferVol?.toString() ?? "",
  }));

  return parsedWorklistValues;
};

export const parseTemplateMethodSettings = (
  worklistTemplate: Maybe<Maybe<WorklistToolTemplateContent>[]> | undefined,
) => {
  if (!worklistTemplate) return;
  //TODO: Refactor + Combine with helpers from HandleUploadWorklist
  const getTemplateRowByTask = (task: string) =>
    worklistTemplate.find((e) => e!.task === task);

  const getTaskDetails_int = (task: string, nullCoalesceValue = "0") =>
    parseInt(getTemplateRowByTask(task)?.details ?? nullCoalesceValue);

  const getTaskDetails_bool = (task: string) =>
    Boolean(getTaskDetails_int(task));

  const getTaskTransferVol = (task: string) =>
    parseInt(getTemplateRowByTask(task)?.transferVol ?? "0");

  const intCentrifugationString =
    getTemplateRowByTask("IntermediateCentrifugation")?.details ?? "";

  const deadTotalPlateString =
    getTemplateRowByTask("DeadTotalPlate")?.details ?? "";

  const seedingStrategyPlateString =
    getTemplateRowByTask("SeedingStrategy")?.details ?? "";

  const getSeedingStrategy = () => {
    const seedingStratString = getValueInDetailsString(
      seedingStrategyPlateString,
      "SeedingStrat",
      "",
    );

    return seedingStratString === "Targeted"
      ? SeedingStrategy.CellCount
      : SeedingStrategy.Volumetric;
  };

  const methodSettings: IExternalThawMethodSettings = {
    selectedSystem: 0,
    arraySystemAutomationMethodId: DefaultWorklistASAMs.ExternalThaw,
    numberOfAliquots: parseInt(
      getValueInDetailsString(deadTotalPlateString, "AliquotNumber"),
    ),
    aliquotVolume: getTaskTransferVol("DeadTotalPlate"),
    spinParamGForce: calculateSpinParamGForce(
      parseInt(getValueInDetailsString(intCentrifugationString, "VSpinRPM")),
    ),
    spinParamPercent: parseInt(
      getValueInDetailsString(intCentrifugationString, "VSpinRPM"),
    ),
    spinTime: parseInt(
      getValueInDetailsString(intCentrifugationString, "VSpinTime"),
    ),
    spinAccel: parseInt(
      getValueInDetailsString(intCentrifugationString, "VSpinAccel"),
    ),
    spinDecel: parseInt(
      getValueInDetailsString(intCentrifugationString, "VSpinDecel"),
    ),
    defaultVSpinSettings: getTaskDetails_bool("DefaultVSpinSettings"),
    seedingStrategy: getSeedingStrategy(),
    splitSeedingVolEvenly: getTaskDetails_bool("SplitSeedingVolEvenly"),
    experimentSettings: "",
    batchDestPlates: false,
    incubationTime: parseInt(
      getValueInDetailsString(deadTotalPlateString, "IncubationTime"),
    ),
  };

  return methodSettings;
};
